module.exports = __webpack_public_path__ + "oneRoster-b94f5b34d0322eb7e2862bd8320f47c5.png";